export default __webpack_public_path__ + "static/media/N.a069b93b.svg";